// Clark Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Barry", location: "NY", product: "The Clark Bartram Bundle", time: "30 minutes ago" },
    { name: "Nathaniel", location: "TX", product: "The Clark Bartram Bundle", time: "1 hour ago" },
    { name: "Rafael", location: "IL", product: "The Clark Bartram Bundle", time: "1 hour 40 minutes ago" },
    { name: "Reggie", location: "AR", product: "The Clark Bartram Bundle", time: "2 hours 20 minutes ago" },
    { name: "Savio", location: "WA", product: "The Clark Bartram Bundle", time: "3 hours ago" },
    { name: "JR", location: "CA", product: "The Clark Bartram Bundle", time: "3 hours 40 minutes ago" },
    { name: "James", location: "IL", product: "The Clark Bartram Bundle", time: "4 hours 20 minutes ago" },
    { name: "Sergio", location: "FL", product: "The Clark Bartram Bundle", time: "5 hours ago" },
    { name: "Jared", location: "WA", product: "The Clark Bartram Bundle", time: "5 hours 40 minutes ago" },
    { name: "Mario", location: "TX", product: "The Clark Bartram Bundle", time: "6 hours 20 minutes ago" },
    { name: "Peter", location: "CA", product: "The Clark Bartram Bundle", time: "32 minutes ago" },
    { name: "Raymond", location: "CA", product: "The Clark Bartram Bundle", time: "1 hour 8 minutes ago" },
    { name: "Ed", location: "CA", product: "The Clark Bartram Bundle", time: "1 hour 45 minutes ago" },
    { name: "Ashley", location: "CA", product: "The Clark Bartram Bundle", time: "2 hours 23 minutes ago" },
    { name: "Edward", location: "GA", product: "The Clark Bartram Bundle", time: "3 hours 2 minutes ago" },
    { name: "Ben", location: "AZ", product: "The Clark Bartram Bundle", time: "3 hours 42 minutes ago" },
    { name: "Scott", location: "TN", product: "The Clark Bartram Bundle", time: "4 hours 23 minutes ago" },
    { name: "Carlos", location: "TX", product: "The Clark Bartram Bundle", time: "5 hours 5 minutes ago" },
    { name: "Joe", location: "NY", product: "The Clark Bartram Bundle", time: "5 hours 48 minutes ago" },
    { name: "Kenneth", location: "GA", product: "The Clark Bartram Bundle", time: "6 hours 32 minutes ago" },
    { name: "Eric", location: "TX", product: "The Clark Bartram Bundle", time: "35 minutes ago" },
    { name: "Rony", location: "ME", product: "The Clark Bartram Bundle", time: "1 hour 14 minutes ago" },
    { name: "James", location: "NY", product: "The Clark Bartram Bundle", time: "1 hour 54 minutes ago" },
    { name: "Mike", location: "ON", product: "The Clark Bartram Bundle", time: "2 hours 35 minutes ago" },
    { name: "Richard", location: "WV", product: "The Clark Bartram Bundle", time: "3 hours 17 minutes ago" },
    { name: "Damen", location: "NJ", product: "The Clark Bartram Bundle", time: "4 hours 1 minute ago" },
    { name: "David", location: "NSW", product: "The Clark Bartram Bundle", time: "4 hours 46 minutes ago" },
    { name: "Qioni", location: "GA", product: "The Clark Bartram Bundle", time: "5 hours 32 minutes ago" },
    { name: "Sidney", location: "OR", product: "The Clark Bartram Bundle", time: "6 hours 19 minutes ago" },
    { name: "John", location: "IN", product: "The Clark Bartram Bundle", time: "7 hours 7 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Clark_Bartram_Bundle_No_Badge.png?v=1733779406" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
